









'use strict';

var _uniqueId=0;

module.exports=function uniqueId(){
return String(_uniqueId++);
};


//////////////////
// WEBPACK FOOTER
// ./~/animated/lib/guid.js
// module id = 242
// module chunks = 0